import { IPaginatedResponse, IResponse } from "../../model";
import ServiceBase from "../../servicebase";
import { IFileContent } from "../services/model";
import { ImportFinal, ImportResultFinal, ImportacionDTO } from "./model/importer.model";

export class ImportadorController extends ServiceBase {
  find = (data:{ pageIndex?: number, pageSize?: number, sort?: string, entity?: string, extraDataJson?: string }) : Promise<IPaginatedResponse<ImportacionDTO>> => 
    this.GetFetch<IPaginatedResponse<ImportacionDTO>>('importador/find', data);

  rollback = (data:{ id?: number }) : Promise<IResponse<void>> => 
    this.DeleteFetch<IResponse<void>>('importador', data);

  test = (data:{ entity: string, extraDataJson: string, content: IFileContent }) : Promise<IResponse<ImportResultFinal>> => 
    this.PostFetch<IResponse<ImportResultFinal>>('importador/test', data);

  importar = (data:{ entity: string, extraDataJson: string, content: IFileContent }) : Promise<IResponse<ImportFinal>> => 
    this.PostFetch<IResponse<ImportFinal>>('importador/importar', data);

  getCSVModel = (data:{ entity?: string }) : Promise<IResponse<string>> => 
    this.GetFetch<IResponse<string>>('importador/csvmodel', data);
}
